import { Component, ViewChild,Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VerEstadosPropuestaComponent } from '../../../forms/estados-propuesta/ver-estados-propuesta/ver-estados-propuesta.component';
import { OrdenEstadoPropuestaDialog } from '../../../forms/estados-propuesta/ordenar-estados-propuesta/ordenar-estado-propuesta-dialog.component';
// import { InformePersonalizadoService } from '../../../providers/informe-personalizado.service';
@Component({
  selector: 'app-estados-propuesta',
  templateUrl: './estados-propuesta.component.html',
  styleUrls: ['./estados-propuesta.component.scss']
})
export class EstadosPropuestaComponent {
  @ViewChild('verEstadoPropuesta') verEstadoPropuesta: VerEstadosPropuestaComponent;
  @Input() tooltipDir: string = 'right';
  flujo: any = null;
  constructor(
    private router: Router,
    public dialogOrden: MatDialog
  ) { }

  ngOnInit() {}

  ordenDialog(){
    console.log(this.verEstadoPropuesta.getFlow())
    
    let dialogOrden = this.dialogOrden.open(OrdenEstadoPropuestaDialog, {
      disableClose: true,
      width: '35vw',
      data: {
        flujo: this.verEstadoPropuesta.getFlow()
      }
    });

    dialogOrden.afterClosed().subscribe(() => {
      this.actualizarTabla();
    });
  }

  cambiarFlujo($event){
    this.flujo = $event.flujo
    console.log(this.flujo, "puede ser pa?");
  }

  actualizarTabla(): void {
    this.verEstadoPropuesta.actualizarTabla();
  }
}
